export default "__VITE_ASSET__23bf43aa__"